module.exports = __webpack_public_path__ + "img/1.85108de3.png";